import GatewayService from "../service/GatewayService";

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export async function registerPushNotifications(): Promise<void> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push notifications not supported in this browser');
    return;
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    console.warn('Push notification permission denied');
    return;
  }

  const registration = await navigator.serviceWorker.register('/service-worker.js');
  await navigator.serviceWorker.ready;

  const vapidPublicKey = await GatewayService.getPushVapidKey();
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  });

  await GatewayService.subscribePush(subscription);

  console.log('Push notifications registered successfully');
}

export async function unregisterPushNotifications(): Promise<void> {
  const registration = await navigator.serviceWorker.getRegistration('/service-worker.js');
  if (!registration) return;

  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    await GatewayService.unsubscribePush(subscription.endpoint);
    await subscription.unsubscribe();
  }
}
